enum ResourcesTranslationVariant {
  title = 'title',
  description = 'description',
  allResources = 'allResources',
  clickAway = 'clickAway',
  myStuff = 'myStuff',
  pinnedResources = 'pinnedResources',
  pinnedAClickAways = 'pinnedAClickAways',
  search = 'search',
  filter = 'filter',
  clickAwayOnly = 'clickAwayOnly',
  clickAwayBuyLink = 'clickAwayBuyLink',
  resourceType = 'resourceType',
  filteredBy = 'filteredBy'
}

export default ResourcesTranslationVariant;
